import { Page } from "@roc/feature-app-core";
import { Route } from "react-router";
import { ClosingAgreedLoans } from "../components/closingAgreedLoans";
import { ClosingAgreedLoansV2 } from "../components/closingAgreedLoansV2";
import { ClosingTodayLoansGrid } from "../components/closingTodayLoansGrid";
import { ClosingNextBusinessDayGrid } from "../components/closingNextBusinessDayGrid";
import { FutureClosingLoansGrid } from "../components/futureClosingLoansGrid";
import { NotClosingLoansGrid } from "../components/notClosingLoansGrid";

export const getClosingAgreedLoansInternalRoutesConfig = (
  basePath: string,
  baseUrl: string,
) => {
  return {
    closingAgreedLoans: {
      path: `${basePath}/closing-agreed-loans`,
      url: `${baseUrl}/closing-agreed-loans`,
      documentTitle: 'closing-agreed-loans',
    },
    closingTodayEmbed: {
      path: `${basePath}/closing-agreed-loans/closing-today`,
      url: `${baseUrl}/closing-agreed-loans/closing-today`,
      documentTitle: 'closing-today',
    },
    closingNextBusinessDayEmbed: {
      path: `${basePath}/closing-agreed-loans/closing-next-business-day`,
      url: `${baseUrl}/closing-agreed-loans/closing-next-business-day`,
      documentTitle: 'closing-next-business-day',
    },
    futureClosingEmbed: {
      path: `${basePath}/closing-agreed-loans/future-closing`,
      url: `${baseUrl}/closing-agreed-loans/future-closing`,
      documentTitle: 'future-closing',
    },
    notClosingEmbed: {
      path: `${basePath}/closing-agreed-loans/not-closing`,
      url: `${baseUrl}/closing-agreed-loans/not-closing`,
      documentTitle: 'not-closing',
    },
  }
}

export const getClosingAgreedLoansInternalRoutes = (
  basePath: string,
  baseUrl: string,
) => {
  const config = getClosingAgreedLoansInternalRoutesConfig(basePath, baseUrl);

  return {
    closingAgreedLoans: (
      <Route exact path={config.closingAgreedLoans.path}>
        <Page routeDefinition={config.closingAgreedLoans}>
          {/*<ClosingAgreedLoans/>*/}
          <ClosingAgreedLoansV2/>
        </Page>
      </Route>
    ),
    closingTodayEmbed: (
      <Route exact path={config.closingTodayEmbed.path}>
        <Page routeDefinition={config.closingTodayEmbed}>
          <ClosingTodayLoansGrid/>
        </Page>
      </Route>
    ),
    closingNextBusinessDayEmbed: (
      <Route exact path={config.closingNextBusinessDayEmbed.path}>
        <Page routeDefinition={config.closingNextBusinessDayEmbed}>
          <ClosingNextBusinessDayGrid/>
        </Page>
      </Route>
    ),
    futureClosingEmbed: (
      <Route exact path={config.futureClosingEmbed.path}>
        <Page routeDefinition={config.futureClosingEmbed}>
          <FutureClosingLoansGrid/>
        </Page>
      </Route>
    ),
    notClosingEmbed: (
      <Route exact path={config.notClosingEmbed.path}>
        <Page routeDefinition={config.notClosingEmbed}>
          <NotClosingLoansGrid/>
        </Page>
      </Route>
    ),
  }
}